function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.9523809523809523s",
  repeatCount: "indefinite"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(17.142857142857142 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.9047619047619048s",
  repeatCount: "indefinite"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(34.285714285714285 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.8571428571428571s",
  repeatCount: "indefinite"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(51.42857142857143 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.8095238095238095s",
  repeatCount: "indefinite"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(68.57142857142857 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.7619047619047619s",
  repeatCount: "indefinite"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(85.71428571428571 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.7142857142857143s",
  repeatCount: "indefinite"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(102.85714285714286 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.6666666666666666s",
  repeatCount: "indefinite"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.6190476190476191s",
  repeatCount: "indefinite"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(137.14285714285714 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5714285714285714s",
  repeatCount: "indefinite"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(154.28571428571428 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5238095238095238s",
  repeatCount: "indefinite"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(171.42857142857142 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.47619047619047616s",
  repeatCount: "indefinite"
})));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(188.57142857142858 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.42857142857142855s",
  repeatCount: "indefinite"
})));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(205.71428571428572 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.38095238095238093s",
  repeatCount: "indefinite"
})));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(222.85714285714286 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.3333333333333333s",
  repeatCount: "indefinite"
})));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.2857142857142857s",
  repeatCount: "indefinite"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(257.14285714285717 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.23809523809523808s",
  repeatCount: "indefinite"
})));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(274.2857142857143 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.19047619047619047s",
  repeatCount: "indefinite"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(291.42857142857144 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.14285714285714285s",
  repeatCount: "indefinite"
})));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(308.57142857142856 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.09523809523809523s",
  repeatCount: "indefinite"
})));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(325.7142857142857 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#668cff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.047619047619047616s",
  repeatCount: "indefinite"
})));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(342.85714285714283 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 29,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#8ba6f7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
})));

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "211px",
    height: "211px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.690f2791.svg";
export { ForwardRef as ReactComponent };